import { Component, Input, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Subject, debounceTime, partition } from "rxjs";
import { FlowQueryModel } from "src/app/models/flowquerymodel";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { UserserviceService } from "src/app/Services/userservice.service";
import { RestrictedAccessComponent } from "../restricted-access/restricted-access.component";
import { DataService } from "../service/data.service";

@Component({
  selector: "app-create-permission",
  templateUrl: "./create-permission.component.html",
  styleUrls: ["./create-permission.component.scss"],
})
export class CreatePermissionComponent implements OnInit {
  @Input() userRoleType!: string; // Input property for the name of the record to be deleted
  @Input() title!: string; // Input property for the name of the record to be deleted
  @Input() description!: string; // Input property for the name of the record to be deleted
  userData: any;
  isdisabled: boolean;
  noResultReturned: boolean;
  userDisplayName: any;
  currenttitlelenght = 0;
  currentdesclenght = 0;
  maxtitlelenght = 150;
  maxdesclenght = 500;
  enableButton: boolean;

  constructor(
    private userserviceService: UserserviceService,
    private router: Router,
    private dataService: DataService,
    public dialogRef: MatDialogRef<RestrictedAccessComponent>
  ) {}

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    if (this.userData == null) {
      this.checkIsUserLoggedIn();
    }
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"]);
    }
  }

  close() {
    this.dialogRef.close();
  }

  submit() {
    var model = {
      partitionKey: this.userData.partitionKey,
      title: this.title,
      userRole: this.userRoleType,
      description: this.description,
    };
    this.dialogRef.close(model);
  }

  descChanged() {
    this.description = this.description.trim();
    if (this.description.length == this.maxdesclenght) {
      this.description = this.description.substring(0, this.description.length);
    }
    if (this.currentdesclenght <= this.maxdesclenght)
      this.currentdesclenght = this.description.length;

    this.setIsDisable();
  }

  titleChanged() {
    this.title = this.title.trim();

    if (this.title.length == this.maxtitlelenght) {
      this.title = this.title.substring(0, this.title.length);
    }

    if (this.currenttitlelenght <= this.maxtitlelenght)
      this.currenttitlelenght = this.title.length;

    this.setIsDisable();
  }

  setIsDisable() {
    if (this.currenttitlelenght > 0 && this.currentdesclenght > 0) {
      this.enableButton = false;
    } else {
      this.enableButton = true;
    }
  }
}
